import React from 'react'
import Hero from '../components/Hero'
import ServicesSection from '../components/ServicesSection'
import FeaturesSection from '../components/FeaturesSection'
import TestimonialsSection from '../components/TestimonialsSection'
import StatsSection from '../components/StatsSection'

const Home = () => {
  return (
    <div>
      <Hero />
      <StatsSection />
      <ServicesSection />
      <FeaturesSection />
      <TestimonialsSection />
    </div>
  )
}

export default Home 